__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "mattermost-webapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@mattermost/client", "*", () => (Promise.all([__webpack_require__.e(7703), __webpack_require__.e(131), __webpack_require__.e(2698), __webpack_require__.e(6640)]).then(() => (() => (__webpack_require__(42698))))));
			register("history", "4.10.1", () => (__webpack_require__.e(2534).then(() => (() => (__webpack_require__(92534))))));
			register("luxon", "3.3.0", () => (__webpack_require__.e(680).then(() => (() => (__webpack_require__(10680))))));
			register("react-beautiful-dnd", "13.1.1", () => (Promise.all([__webpack_require__.e(6891), __webpack_require__.e(9604), __webpack_require__.e(4390), __webpack_require__.e(9372), __webpack_require__.e(314), __webpack_require__.e(3487)]).then(() => (() => (__webpack_require__(69604))))));
			register("react-bootstrap", "github:mattermost/react-bootstrap#d821e2b1db1059bd36112d7587fd1b0912b27626", () => (Promise.all([__webpack_require__.e(368), __webpack_require__.e(2565), __webpack_require__.e(4390), __webpack_require__.e(9372), __webpack_require__.e(8304)]).then(() => (() => (__webpack_require__(42565))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(1542), __webpack_require__.e(4390)]).then(() => (() => (__webpack_require__(31542))))));
			register("react-intl", "*", () => (Promise.all([__webpack_require__.e(5896), __webpack_require__.e(4390)]).then(() => (() => (__webpack_require__(65896))))));
			register("react-redux", "7.2.4", () => (Promise.all([__webpack_require__.e(4617), __webpack_require__.e(4390), __webpack_require__.e(9372)]).then(() => (() => (__webpack_require__(24617))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(4404), __webpack_require__.e(4390), __webpack_require__.e(4348)]).then(() => (() => (__webpack_require__(94404))))));
			register("react", "17.0.2", () => (__webpack_require__.e(7378).then(() => (() => (__webpack_require__(27378))))));
			register("styled-components", "5.3.6", () => (Promise.all([__webpack_require__.e(8039), __webpack_require__.e(5620), __webpack_require__.e(4390)]).then(() => (() => (__webpack_require__(55620))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};